<template>
  <div class="flex flex-wrap">
    <div v-for="group in gruposNormalizados" :key="group.id"
      class="rounded-full mr-1 mb-1 pl-1 pr-1 border-2"
      :class="[
        group.idTipo === 1 ? 'bg-primary-800 dark:bg-darkblue text-white group-pool' : 
        group.idTipo === 2  ? 'bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 group-border' : 
        group.idTipo === 3  ? 'bg-secondary-600 dark:bg-secondary-600 text-white group-reparto' : ''
      ]">
      <GroupTagTooltip :group="group" />
    </div>
</div>
</template>

<script>
import GroupTagTooltip from './GroupTagTooltip.vue'
export default {
  name: 'groups-tags',
  components: {
    GroupTagTooltip
  },
  props: {
    Grupos: {
      type: [Object, Array],
      required: false,
      default: null
    },
  },
  computed: {
    gruposNormalizados () {
      if (!this.Grupos) return []
      return Array.isArray(this.Grupos) ? this.Grupos : [this.Grupos]
    }
  }
}
</script>
